import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Tooltip } from 'antd';
import cs from 'classnames';

import { selectClientTier } from 'features/auth/authSelectors';

import { ClientTierFeatures, ClientTiers } from 'constants/enums';
import { CLIENT_TIER_NAMES } from 'constants/uiSettings';

import styles from './TierPermissionsWrapper.module.scss';
import { CLIENT_TIERS_PRIORITY_INDEXES } from './constants';

interface TierPermissionsWrapperProps {
  children: React.ReactNode;
  minimalTier: ClientTiers;
  isDisplayWhenUnavailable?: boolean;
  feature?: ClientTierFeatures;
  placement?: 'left' | 'right' | 'top' | 'bottom';
}

const TierPermissionsWrapper: FC<TierPermissionsWrapperProps> = ({
  children,
  minimalTier,
  isDisplayWhenUnavailable,
  feature,
  placement = 'top'
}) => {
  const currentTier = useSelector(selectClientTier);
  const { t } = useTranslation();

  const isAvailable = useMemo(() => {
    return true;
    // TODO: Return the logic when we'll use tier limitations

    // if (!currentTier) {
    //   return false;
    // }

    // const currentTierPriority =
    //   CLIENT_TIERS_PRIORITY_INDEXES.indexOf(currentTier);

    // const minimalTierPriority =
    //   CLIENT_TIERS_PRIORITY_INDEXES.indexOf(minimalTier);

    // return currentTierPriority >= minimalTierPriority;
  }, [currentTier, minimalTier]);

  if (!isAvailable && !isDisplayWhenUnavailable) {
    return null;
  }

  const minimalTierName = CLIENT_TIER_NAMES[minimalTier];
  const tooltipText = `${t('tiers.label.upgradeTo', {
    tier: minimalTierName,
    feature
  })}`;
  const isShowTooltip = !isAvailable && Boolean(feature);

  return (
    <>
      {isShowTooltip ? (
        <Tooltip trigger={'hover'} title={tooltipText} placement={placement}>
          <div className={cs(styles.wrap, { [styles.disabled]: !isAvailable })}>
            {children}
          </div>
        </Tooltip>
      ) : (
        children
      )}
    </>
  );
};

export default TierPermissionsWrapper;
